import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Black } from '../../../constants/Colors';
import FormStylesOptions from '../../../constants/FormStylesOptions';

const StyledTitle = styled.label`
  margin-bottom:4px;
  font-size: ${(props) => (props.titleFontSize !== undefined ? `${props.titleFontSize}px` : '12px')};
  color: ${(props) => props.titleFontColor || Black};
  text-align: ${(props) => props.titleTextAlign || 'left'};
  font-style: ${(props) => props.titleFontStyle || 'normal'};
  font-weight: ${(props) => props.titleFontWeight || 'bold'};
  text-transform: ${(props) => props.titleTextTransform || 'none'};
  text-decoration: ${(props) => props.titleTextDecoration || 'none'};
`;

const FieldTitle = ({
  title,
  titleDisplay,
  titleFontSize,
  titleFontColor,
  titleTextAlign,
  titleFontStyle,
  titleFontWeight,
  titleTextTransform,
  titleTextDecoration,
  onRef
}) => {

  if (!title || titleDisplay === FormStylesOptions.displayNone) return null;

  return (
    <StyledTitle
      ref={(e) => {
        if (e && onRef) onRef(e);
      }}
      {...{
        titleFontSize,
        titleFontColor,
        titleTextAlign,
        titleFontStyle,
        titleFontWeight,
        titleTextTransform,
        titleTextDecoration,
      }}
    >
      {title}
    </StyledTitle>
  );

};

FieldTitle.propTypes = {
  onRef: PropTypes.func,
  title: PropTypes.string,
  titleDisplay: PropTypes.string,
  titleFontSize: PropTypes.number,
  titleFontColor: PropTypes.string,
  titleTextAlign: PropTypes.string,
  titleFontStyle: PropTypes.string,
  titleFontWeight: PropTypes.string,
  titleTextTransform: PropTypes.string,
  titleTextDecoration: PropTypes.string,
};

export default React.memo(FieldTitle);
